var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommercial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1665 13.1334L10.6723 14.8543C11.0957 15.3382 11.8591 15.3025 12.2356 14.7813L15.8332 9.80005",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2128 4.14026C10.7941 3.64489 11.0847 3.3972 11.3886 3.25195C12.0915 2.91602 12.9085 2.91602 13.6114 3.25195C13.9153 3.3972 14.2059 3.64489 14.7872 4.14026C15.3856 4.65023 15.9938 4.90761 16.7939 4.97146C17.5552 5.03222 17.9359 5.06259 18.2535 5.17477C18.988 5.43421 19.5658 6.01198 19.8252 6.74652C19.9374 7.0641 19.9678 7.44476 20.0285 8.20608C20.0924 9.00621 20.3498 9.61436 20.8597 10.2128C21.3551 10.7941 21.6028 11.0847 21.748 11.3886C22.084 12.0915 22.084 12.9085 21.748 13.6114C21.6028 13.9153 21.3551 14.2059 20.8597 14.7872C20.3391 15.3981 20.0911 16.0102 20.0285 16.7939C19.9678 17.5552 19.9374 17.9359 19.8252 18.2535C19.5658 18.988 18.988 19.5658 18.2535 19.8252C17.9359 19.9374 17.5552 19.9678 16.7939 20.0285C15.9938 20.0924 15.3856 20.3498 14.7872 20.8597C14.2059 21.3551 13.9153 21.6028 13.6114 21.748C12.9085 22.084 12.0915 22.084 11.3886 21.748C11.0847 21.6028 10.7941 21.3551 10.2128 20.8597C9.60185 20.3391 8.98984 20.0911 8.20608 20.0285C7.44476 19.9678 7.0641 19.9374 6.74652 19.8252C6.01198 19.5658 5.43421 18.988 5.17477 18.2535C5.06259 17.9359 5.03222 17.5552 4.97146 16.7939C4.90761 15.9938 4.65023 15.3856 4.14026 14.7872C3.64489 14.2059 3.3972 13.9153 3.25195 13.6114C2.91602 12.9085 2.91602 12.0915 3.25195 11.3886C3.3972 11.0847 3.64489 10.7941 4.14026 10.2128C4.66089 9.60185 4.90892 8.98984 4.97146 8.20608C5.03222 7.44476 5.06259 7.0641 5.17477 6.74652C5.43421 6.01198 6.01198 5.43421 6.74652 5.17477C7.0641 5.06259 7.44476 5.03222 8.20608 4.97146C9.00621 4.90761 9.61436 4.65023 10.2128 4.14026Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommercial);
export default __webpack_public_path__ + "static/media/commercial.d90bf85d6718a27a7cb95f1091a78e25.svg";
export { ForwardRef as ReactComponent };